import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShieldHalved, faCircleCheck, faFilePdf, faDownload } from '@fortawesome/free-solid-svg-icons'

const highlights = [
  'Berdasarkan Peraturan Gubernur Kalimantan Selatan Nomor 77 Tahun 2018',
  'Transparansi dalam penanganan setiap laporan',
  'Perlindungan penuh bagi pelapor beritikad baik',
]

export default function TentangSection({ documents = [] }) {
  return (
    <section id="tentang" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-blue-600 text-sm font-bold uppercase tracking-widest">Tentang WBS</span>
            <h2 className="mt-3 text-3xl lg:text-4xl font-extrabold text-slate-900 leading-tight">
              Platform Pelaporan Resmi yang Aman dan Terpercaya
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              Whistleblowing System (WBS) Pemerintah Provinsi Kalimantan Selatan adalah platform digital resmi yang dirancang untuk memberikan ruang aman bagi seluruh masyarakat, ASN, dan pemangku kepentingan dalam melaporkan dugaan penyimpangan di lingkungan pemerintahan.
            </p>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Setiap laporan ditangani oleh tim independen yang profesional dan berkomitmen menjaga kerahasiaan identitas pelapor sesuai amanat peraturan perundang-undangan.
            </p>
            <div className="mt-8 space-y-3">
              {highlights.map(item => (
                <div key={item} className="flex items-start gap-3">
                  <FontAwesomeIcon icon={faCircleCheck} className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700 text-sm">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Visual card */}
          <div className="relative">
            <div className="relative bg-gradient-to-br from-blue-900 to-blue-700 rounded-3xl p-8 text-white overflow-hidden">
              <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/20 rounded-full -translate-y-1/2 translate-x-1/2" />
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-800/40 rounded-full translate-y-1/3 -translate-x-1/4" />
              <div className="relative">
                <FontAwesomeIcon icon={faShieldHalved} className="w-16 h-16 text-blue-300 mb-6" />
                <h3 className="text-2xl font-bold mb-4">Komitmen Kami</h3>
                <p className="text-blue-100 text-sm leading-relaxed mb-6">
                  Setiap laporan yang masuk diperlakukan dengan serius, dirahasiakan dengan ketat, dan ditindaklanjuti secara profesional demi mewujudkan tata kelola pemerintahan yang bersih dan akuntabel.
                </p>

                {documents.length > 0 && (
                  <div className="mt-6 border-t border-white/10 pt-5">
                    <p className="text-xs font-semibold text-blue-300 uppercase tracking-widest mb-3">Unduh Dokumen</p>
                    <div className="space-y-2">
                      {documents.map(doc => (
                        <a
                          key={doc.id}
                          href={doc.url}
                          className="flex items-center gap-3 bg-white/5 hover:bg-white/15 border border-white/10 hover:border-white/25 rounded-xl px-3.5 py-2.5 transition-all group"
                        >
                          <div className="w-7 h-7 rounded-lg bg-red-400/20 flex items-center justify-center flex-shrink-0">
                            <FontAwesomeIcon icon={faFilePdf} className="w-3.5 h-3.5 text-red-300" />
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="text-sm font-medium text-white truncate leading-tight">{doc.title}</div>
                            <div className="text-[11px] text-blue-300/70">{doc.created_at}</div>
                          </div>
                          <FontAwesomeIcon icon={faDownload} className="w-3.5 h-3.5 text-blue-300/50 group-hover:text-blue-200 flex-shrink-0 transition-colors" />
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
